import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import pluralize from 'pluralize';
import * as React from 'react';
import { PortCollection } from 'types/Port';

interface Props {
  portCollections: PortCollection[];
  onChange: (port: string[]) => void;
  value: string[];
}

export const PortCollectionSelector: React.FC<Props> = (props) => {
  const { onChange, value, portCollections } = props;

  const allRegionsSelected = portCollections.length === value.length;

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value: v },
    } = event;
    if (v.includes('__all__')) {
      if (allRegionsSelected) {
        onChange([]);
      } else {
        onChange(portCollections.map((p) => p.code));
      }
      return;
    }

    onChange(v as string[]);
  };

  const items = React.useMemo(() => {
    return portCollections.map((portCollection) => (
      <MenuItem key={portCollection.code} value={portCollection.code}>
        <Checkbox checked={value.includes(portCollection.code)} />
        <ListItemText primary={portCollection.name} />
      </MenuItem>
    ));
  }, [portCollections, value]);

  return (
    <FormControl fullWidth className="space-y-1">
      <h4 className="font-medium">What are your regions of operations? Select all that apply.</h4>
      <Select
        value={value}
        multiple
        onChange={handleChange}
        displayEmpty
        renderValue={(values) => {
          const count = values.length;
          if (count > 0) {
            return (
              <h4>
                {allRegionsSelected ? 'All ' : ''}
                {count} {pluralize('region', count)} selected
              </h4>
            );
          }
          return <h4>Select all your regions of operations from the list</h4>;
        }}
      >
        <MenuItem value="__all__">
          <Checkbox checked={allRegionsSelected} />
          <ListItemText primary="Select all regions" />
        </MenuItem>
        {items}
      </Select>
    </FormControl>
  );
};
PortCollectionSelector.displayName = 'CompanyDetails.Shippers.PortCollectionSelector';
